<template>
  <div>
    <el-carousel :height="swiperHeight" arrow="always" :interval="changTime" indicator-position="none" v-show="bannerList.length">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <!-- 图片 -->
        <!-- <img :src="item.picUrl" v-if="item.type === 2" @click="jumpNew(item.linkUrl == '' ? '/' :item.linkUrl.indexOf('home.tianan')==-1?'http://wechat.tianan.net/zpop?url='+item.linkUrl:item.linkUrl)" :class="{ 'hasUrl': item.linkUrl }" :style="{'height': swiperHeight}"> -->
        <img :src="item.picUrl" v-if="item.type === 2" @click="jumpNew(item.linkUrl == '' ? '/' :item.linkUrl)" :class="{ 'hasUrl': item.linkUrl }" :style="{'height': swiperHeight}">
      <!-- 视频 -->
        <img :src="item.picUrl" alt="" v-if="item.type === 1" class="videos">
        <span class="playVideo" v-if="item.type === 1" @click="openMask(item.videoUrl)">
          <i class="el-icon-caret-right"></i>
        </span>
      </el-carousel-item>
    </el-carousel>

     <!-- 遮罩层播放视频 -->
    <div class="mask" v-show="maskFlag">
      <div class="close">
        <span @click="closeMask">X</span>
      </div>
      <div class="content">
        <video :src="videoUrl" controls :autoplay="maskFlag" @click="playVideo">您的浏览器暂不支持播放该视频，请升级至最新版浏览器。</video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      maskFlag: false,
      videoUrl: null,
      changTime: 5000,
    }
  },
  props: {
    bannerList: {
      type: Array,
      default() {
        return [];
      },
    },
    swiperHeight: {
      type: String,
      default: '470px',
    }
  },
  methods: {
    jumpNew(linkUrl) {
      if (linkUrl) {
        window.open(linkUrl);
      }
    },
    openMask(src) {  // 弹框播放视频
      this.maskFlag = true;
      this.videoUrl = src;
      document.body.style.overflow = 'hidden';
    },
    closeMask() {  // 关闭遮罩层暂停视频
      this.maskFlag = false;
      document.body.style.overflow = 'auto';
      this.$el.querySelector('.mask video').pause();
    },
    playVideo() {   // 点击视频播放
      this.$el.querySelector('.mask video').play();
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss';

.mask {
  @include swiper_mask;
}
.el-carousel__item img, .el-carousel__item video {
  width: 100%;
  height: 100%;
  position: relative;
  // object-fit: cover;
}
.el-carousel__item .videos {
  width: 800px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.el-carousel__item {
  background-color: #e4e4e4;
  color: #000;
  .playVideo {
    position: absolute;
    width: 100px;
    height: 100px;
    background-color: rgba(0,0,0,.8);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 80px;
    }
    &:hover {
      background-color: #000;
      i {
        color: #e4e4e4;
      }
    }
  }
  img.hasUrl {
    cursor: pointer;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Swiper.vue